import React, { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import { getAdminBidsRoutine, setBidStatusRoutine } from 'state/bid/bid.routines';
import { bidsSelector } from 'state/bid/bid.selectors';

import { BID_STATUS } from 'schema/bid';

import BidList from 'components/bid-list/bid-list.component';
import Page from 'components/page/page.component';

const Bids = ({ history }) => {
    const dispatch = useDispatch();
    const { bids } = useSelector(bidsSelector);

    const handleViewBidClick = ({ id }) => {
        if (history) history.push(`/admin/bid/${id}`);
    };

    const handleApproveBidClick = ({ bid: { status, ...rest } }) => {
        if (dispatch)
            dispatch(
                setBidStatusRoutine.trigger({
                    status: BID_STATUS.APPROVED,
                    dateApproved: moment().format('YYYY-MM-DD HH:mm:ss'),
                    ...rest
                })
            );
    };

    const handleRejectBidClick = ({ bid: { status, ...rest } }) => {
        if (dispatch)
            dispatch(
                setBidStatusRoutine.trigger({
                    status: BID_STATUS.REJECTED,
                    dateRejected: moment().format('YYYY-MM-DD HH:mm:ss'),
                    ...rest
                })
            );
    };

    const handleReviewBid = ({ bid: { status, ...rest } }) => {
        if (dispatch) {
            dispatch(
                setBidStatusRoutine.trigger({
                    status: BID_STATUS.UNDER_REVIEW,
                    dateUnderReview: moment().format('YYYY-MM-DD HH:mm:ss'),
                    ...rest
                })
            );
        }
    };

    useEffect(() => {
        dispatch(getAdminBidsRoutine.trigger());
    }, []);

    return (
        <Page noHero pageContentStyle={{ minHeight: '800px', width: '100%', padding: 0 }}>
            <Container fluid className="mb-5 mt-2">
                <Row>
                    <Col>
                        <h1 className="h2">Bids</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <BidList
                            bids={bids}
                            onViewBid={handleViewBidClick}
                            onApproveBid={handleApproveBidClick}
                            onRejectBid={handleRejectBidClick}
                            onReviewBid={handleReviewBid}
                        />
                    </Col>
                </Row>
            </Container>
        </Page>
    );
};

export default withRouter(Bids);
